export const config = {
  id: 'telesales',
  path: '/telesales',
  show: () => true,
};
